<template>
  <section class="content">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Inventario</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="/">Home</a></li>
              <li class="breadcrumb-item active">Inventario</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4">
          <div id="btn-mover-mercancia" class="info-box mb-3">
            <router-link to="/movform" class="btn btn-block info-box-icon bg-info elevation-1">
              <i class="fas fa-right-left"></i>
            </router-link>
            <div class="info-box-content">
              <span class="info-box-text">Mover Mercancia</span>
              <span class="info-box-number">Entrada - Salida</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <router-link to="/auditoria" class="btn btn-block info-box-icon bg-warning elevation-1"><i class="fas fa-file-circle-question"></i></router-link>
            <div class="info-box-content">
              <span class="info-box-text">Auditar</span>
              <span class="info-box-number">Realizar Auditoria</span>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-4">
          <div class="info-box mb-3">
            <button @click="descargarPDF" class="btn btn-block info-box-icon bg-success elevation-1"><i class="fas fa-print"></i></button>
            <div class="info-box-content">
              <span class="info-box-text">Reporte</span>
              <span class="info-box-number">Guardar - Imprimir</span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="card-title">Inventario General</h3>
                </div>
                <!-- Botón dropdown de filtros -->
                <div class="col-auto">
                  <div class="container-fluid mb-3">
                    <div class="dropdown d-inline-block">
                      <button ref="toggleFiltros" class="btn btn-info dropdown-toggle" type="button" id="ddlFiltros"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fas fa-filter"></i> Filtros
                      </button>
                      <div class="dropdown-menu p-3 dropdown-menu-right" aria-labelledby="ddlFiltros"
                        style="min-width: 280px;" @click.stop>
                        <div class="form-group">
                          <label>Proveedor</label>
                          <select v-model="proveedorSeleccionado" @change="filtrarProductos" class="form-control mr-3">
                            <option value="">Todos los proveedores</option>
                            <option v-for="proveedor in proveedores" :key="proveedor.id" :value="proveedor.id">
                              {{ proveedor.descripcion }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Categoria</label>
                          <select v-model="categoriaSeleccionada" @change="filtrarProductos" class="form-control mr-3">
                            <option value="">Todas las categorías</option>
                            <option v-for="categoria in categoriasFiltradas" :key="categoria.id" :value="categoria.id">
                              {{ categoria.descripcion }}
                            </option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label>Almacén</label>
                          <select class="form-control" v-model="almacenSeleccionado">
                            <option value="">Todos los almacenes</option>
                            <option v-for="almacen in almacenes.filter(a => a.estatus)" :key="almacen.id" :value="almacen.id">
                              {{ almacen.descripcion }}
                            </option>
                          </select>
                        </div>
                        <div class="d-flex justify-content-between mt-2">
                          <button class="btn btn-sm btn-outline-secondary" @click="limpiarFiltros">
                            Limpiar
                          </button>
                          <button class="btn btn-sm btn-primary" @click="$refs.toggleFiltros.click()">
                            Cerrar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <table id="tablaInventario" class="table table-bordered table-striped">
              </table>


            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </section>
  <!-- /.content -->
</template>
<script setup>
import { ref, computed, onMounted, watch, onUnmounted } from 'vue'
import api from '@/services/api'
import { tutorial } from "@/plugins/tutorial";

// 1) Refs de filtros y datos
const proveedores = ref([])
const categorias = ref([])
const almacenes = ref([])
const inventarios = ref([])
const proveedorSeleccionado = ref('')
const categoriaSeleccionada = ref('')
const almacenSeleccionado = ref("")

let dtInstance = null

// 2) Filtrar categorías por proveedor
const categoriasFiltradas = computed(() => {
  if (!proveedorSeleccionado.value) return categorias.value
  return categorias.value.filter(
    c => c.proveedor_id === +proveedorSeleccionado.value
  )
})

// 3) Filtrar inventarios por proveedor, categoría *y* almacén
const inventariosFiltrados = computed(() => {
  const catIds = new Set(categoriasFiltradas.value.map(c => c.id))

  return inventarios.value.filter(item => {
    if (
      proveedorSeleccionado.value &&
      !catIds.has(item.producto.categoria_id)
    ) return false

    if (
      categoriaSeleccionada.value &&
      item.producto.categoria_id !== +categoriaSeleccionada.value
    ) return false

    if (
      almacenSeleccionado.value &&
      item.almacen_id !== +almacenSeleccionado.value
    ) return false

    return true
  })
})

// 4) Agrupar y formatear el stock **después** de aplicar todos los filtros
const inventariosAgrupados = computed(() => {
  const map = new Map()

  inventariosFiltrados.value.forEach(item => {
    const pid = item.producto_id
    const cantidad = Number(item.cantidad) || 0
    const porCaja = Number(item.producto.cantxcaja) || 1
    const { codigo, descripcion } = item.producto

    if (!map.has(pid)) {
      map.set(pid, {
        producto_id: pid,
        codigo,
        descripcion,
        cantxcaja: porCaja,
        totalUnidades: 0
      })
    }
    map.get(pid).totalUnidades += cantidad
  })

  return Array.from(map.values()).map(grupo => {
    const { totalUnidades, cantxcaja } = grupo
    const cajas = Math.trunc(totalUnidades / cantxcaja)
    const unidades = totalUnidades % cantxcaja

    let stockStr = ''
    if (cajas && unidades) stockStr = `${cajas}CJ + ${unidades}UN`
    else if (cajas) stockStr = `${cajas}CJ`
    else if (unidades) stockStr = `${unidades}UN`
    else stockStr = '0'

    return {
      producto_id: grupo.producto_id,
      codigo: grupo.codigo,
      descripcion: grupo.descripcion,
      stock: stockStr
    }
  })
})

// 5) Inicializar o refrescar DataTable
function initTable() {
  const data = inventariosAgrupados.value

  if (!dtInstance) {
    dtInstance = $('#tablaInventario').DataTable({
      data,
      columns: [
        { data: 'codigo', title: 'Código' },
        { data: 'descripcion', title: 'Descripción' },
        { data: 'stock', title: 'Stock', className: 'text-center' },
        {
          data: 'producto_id',
          title: 'Acciones',
          orderable: false,
          className: 'text-center',
          render: pid => `
            <a
              class="btn btn-sm btn-primary ver-mas"
              href="/inventario/producto/${pid}"
            >
              Ver más
            </a>`
        }
      ],
      responsive: true,
      autoWidth: false,
      pageLength: 10,
      lengthChange: false,
      pagingType: 'numbers',
      language: {
        url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
      },
      dom:
        '<"row mb-3"<"col-12 col-md-6"f>>' +
        't' +
        '<"row mt-3"<"col-12 text-center"i>>' +
        '<"row"<"col-12 d-flex justify-content-center"p>>'
    })
  } else {
    dtInstance.clear()
    dtInstance.rows.add(data)
    dtInstance.draw(false)
  }
}
function limpiarFiltros() {
  almacenSeleccionado.value = ''
  proveedorSeleccionado.value = ''
  categoriaSeleccionada.value = ''
}

async function descargarPDF() {
  try {
    const response = await api.get('/pdf/inventario', {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'inventario.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error al descargar el PDF:", error);
    alert("No se pudo generar el reporte en este momento.");
  }
}

async function realizarAuditoria() {
  try {
    const response = await api.post('/inventario/auditar', {}, {
      responseType: 'blob'
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'auditoria_inventario.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error al realizar la auditoría:", error);
    alert("No se pudo realizar la auditoría en este momento.");
  }
}

// 6) Cargar datos y primer init
onMounted(async () => {
  const [p, c, a, i] = await Promise.all([
    api.get('/proveedor'),
    api.get('/categoria'),
    api.get('/almacen'),
    api.get('/inventario')
  ])

  proveedores.value = p.data
  categorias.value = c.data
  almacenes.value = a.data
  inventarios.value = i.data
})

onMounted(() => {
  tutorial.set(iniciarTutorial);
});

onUnmounted(() => {
  if (dtInstance) {
    window.$('#tablaInventario tbody').off('click.tutorial');
    dtInstance.destroy();
    dtInstance = null;
  }
  tutorial.set(null);
});

// 7) Cada vez que cambien filtros o inventarios se refresca la tabla
watch(
  [proveedorSeleccionado, categoriaSeleccionada, almacenSeleccionado, inventarios],
  initTable,
  { deep: false }
)

function iniciarTutorial() {
  const steps = [
    {
      element: '#btn-mover-mercancia',
      title: 'Mover Mercancía',
      text: 'Haz clic aquí para registrar entradas o salidas de inventario.',
      position: 'bottom'
    },
    {
      element: '#ddlFiltros',
      title: 'Filtrar Inventario',
      text: 'Usa este botón para filtrar el inventario por proveedor, categoría o almacén.',
      position: 'bottom'
    },
    {
      element: '#tablaInventario',
      title: 'Stock de Productos',
      text: 'Aquí verás la lista de productos y su stock actual.',
      position: 'top'
    }
  ];

  const table = window.$('#tablaInventario');
  const isCollapsed = table.hasClass('collapsed');
  const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

  if (isCollapsed && !actionsVisible) {
    const firstRow = table.find('tbody tr:first-child');

    if (firstRow.hasClass('parent')) {
      firstRow.find('td:first-child').click();
    }

    steps.push({
      element: '#tablaInventario tbody tr:first-child td:first-child',
      title: 'Ver Detalles',
      text: 'En pantallas pequeñas, haz clic en el símbolo (+) para ver los datos ocultos y las acciones.',
      position: 'bottom',
      tooltipClass: 'hide-next-btn'
    });

    firstRow.off('click.tutorial').on('click.tutorial', function () {
      setTimeout(() => {
        const tooltip = document.querySelector('.introjs-tooltip');
        if (tooltip) {
          tooltip.classList.toggle('hide-next-btn', !window.$(this).hasClass('parent'));
        }
      }, 200);
    });

    steps.push({
      element: '.dtr-details .ver-mas',
      title: 'Ver Detalles del Producto',
      text: 'Haz clic aquí para ver el historial de movimientos y más detalles del producto.',
      position: 'left'
    });
  } else {
    steps.push({
      element: '#tablaInventario .ver-mas',
      title: 'Ver Detalles del Producto',
      text: 'Haz clic aquí para ver el historial de movimientos y más detalles del producto.',
      position: 'left'
    });
  }

  tutorial.start(steps);
}
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>